import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

export const FavoritesCardListSkeleton = () => {
  return <Skeleton />;
};
